 /**Announcement Bar Start**/
function setCookie(cname,cvalue,exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  let annunce = getCookie("annuncy");
  const announcementbarsrn = document.querySelector(".announcementbar-scn");
  if( !announcementbarsrn ){
    return false;
  }
  const header = document.querySelector("header");
  if ( annunce != "" ) {
    announcementbarsrn.classList.add("hide");
    document.querySelector('body').classList.remove("announce-b-body");
    header.classList.remove("top-announce");
  }else{
    announcementbarsrn.classList.remove("hide");
    header.classList.add("top-announce");
  }
}
checkCookie();
const announceclose = document.querySelector(".announce-close");
if( announceclose ){
 announceclose.addEventListener("click", function () {
    setCookie("annuncy", true, 30);
    document.querySelector('.announcementbar-scn').classList.add('hide');
    document.querySelector("header").classList.remove("top-announce");
    document.querySelector('body').classList.remove("announce-b-body");
  }); 
}
/**Announcement Bar End**/
